import { apiUri } from '../../constants/Constants';
import { client } from '../axios/axiosClient';

export type featureFlagData = {
  data: featureFlagValues;
};

export type featureFlagValues = {
  test: boolean;
  enable_smb_help_center: boolean;
  is_new_smb_portfolio_amount: boolean;
  enable_embedded_calendar_for_enterprise: boolean;
  remove_units_owned: boolean;
  remove_1_50_from_size_of_portfolio: boolean;
};

const getFeatureFlags = async () => {
  return await client.get(apiUri.getFeatureFlags).then((value: featureFlagData) => {
    return value.data;
  });
};

export default getFeatureFlags;
